import { useCallback, useEffect, useState } from 'react';

/**
 * A flag that `flash()` turns on for `durationMs`, such as a "Copied" confirmation. Flashing again
 * restarts the wait, and unmounting cancels it, so no timer outlives the component.
 */
export function useFlashFlag(durationMs: number): [boolean, () => void] {
  const [flashId, setFlashId] = useState<number | null>(null);
  useEffect(() => {
    if (flashId === null) return;
    const timer = setTimeout(() => setFlashId(null), durationMs);
    return () => clearTimeout(timer);
  }, [flashId, durationMs]);
  const flash = useCallback(() => setFlashId((id) => (id ?? 0) + 1), []);
  return [flashId !== null, flash];
}
